import { useEffect } from 'react';
import { Link } from 'wouter';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from "@/components/ui/card";

export default function NotFound() {
  // Update document title for better accessibility
  useEffect(() => {
    document.title = 'Page Not Found | SW Accounting';
    
    // Report to analytics that a 404 occurred (if analytics are set up)
    if ((window as any).gtag) {
      (window as any).gtag('event', 'page_not_found', {
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 py-12 bg-[#f8f9fa]">
      <div className="text-center max-w-2xl mx-auto">
        <h1 className="text-6xl font-bold text-[#1a365d] mb-4">404</h1>
        <div className="w-20 h-1 bg-[#7d9b76] mx-auto mb-6"></div>
        
        <div className="mb-8">
          <img 
            src="/favicon.svg" 
            alt="SW Accounting Logo" 
            className="w-24 h-auto mx-auto"
            loading="eager"
            width={96}
            height={96}
          />
        </div>
        
        <h2 className="text-2xl md:text-3xl font-serif text-[#1a365d] mb-4">
          We couldn't find that page
        </h2>
        
        <p className="text-gray-600 mb-8">
          The page you're looking for may have been moved or doesn't exist. 
          Let's get you back on track.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button 
            asChild 
            className="bg-[#1a365d] hover:bg-[#132845] transition-colors"
            aria-label="Return to home page"
          >
            <Link href="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          
          <Button 
            asChild 
            variant="outline"
            className="border-[#7d9b76] text-[#7d9b76] hover:bg-[#7d9b76] hover:text-white transition-colors"
            aria-label="Contact us for assistance"
          >
            <Link href="/contact">
              Contact Us
            </Link>
          </Button>
        </div>
        
        <div className="mt-12">
          <h3 className="text-xl font-serif text-[#1a365d] mb-3">Popular Pages</h3>
          <ul className="space-y-2">
            <li>
              <Link href="/services" className="text-[#7d9b76] hover:underline">
                Our Services
              </Link>
            </li>
            <li>
              <Link href="/booking" className="text-[#7d9b76] hover:underline">
                Book a Consultation
              </Link>
            </li>
            <li>
              <Link href="/about" className="text-[#7d9b76] hover:underline">
                About Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
